// extracted by mini-css-extract-plugin
export var quillEditor = "_oh-1";
export var variable = "_oh-0";